import ContabilitaDocumentiListPage from "./pages/ContabilitaDocumentiListPage.vue";
// import ContabilitaDocumentiEditPage from "./pages/ContabilitaDocumentiEditPage.vue";
// import ContabilitaDocumentiViewPage from "./pages/ContabilitaDocumentiViewPage.vue";
// import ContabilitaDocumentoSoggettoListPage from "./pages/ContabilitaDocumentoSoggettoListPage.vue";

export default {
	ContabilitaDocumentiListPage,
	// ContabilitaDocumentiViewPage,
	// ContabilitaDocumentiEditPage,
	// ContabilitaDocumentoSoggettoListPage,
};
